import ViewDisplayPoster from "./ViewDisplayPoster";

export default ViewDisplayPoster;